import axios from "axios";
import toast from "react-hot-toast";

const baseURL = process.env.REACT_APP_API_URL;
console.log("r[ee", baseURL);

const getBearerToken = () =>
  `Bearer ${localStorage.getItem("lms_access_token")}`;

const axiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "1",
    Authorization: getBearerToken(),
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("lms_access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error("Request error:", error);
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { data } = error.response;
      const errorMessage = data?.message || "Some unknown error";
      console.log(errorMessage);

      if (errorMessage === "Unauthorized") {
        // Logout logic
        toast.error("Unauthorized request. Logging out...");
        localStorage.removeItem("lms_access_token");
        window.location.reload();
      }

      return Promise.reject(new Error(errorMessage));
    }

    return Promise.reject(new Error("Network error"));
  }
);

// export const get = async (url, params) => axiosInstance.get(url, { params });
// export const post = async (url, params) => axiosInstance.post(url, params);

export default axiosInstance;
